import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import {
  Erc998Section,
  Erc998Composition,
  Erc998Contract,
  Erc998Template,
  Erc998Token,
  IndexWrapper,
  ServiceType,
} from "@framework/shared";

export const erc998Routes: Array<RouteObject> = [
  {
    path: "/erc998",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="erc998">
            <Erc998Section />
          </IndexWrapper>
        ),
      },
      {
        path: "/erc998/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <Erc998Contract service={ServiceType.ADMIN} /> },
          { path: "/erc998/contracts/:id/:action", element: <Erc998Contract service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/erc998/templates",
        element: <Protected />,
        children: [
          { index: true, element: <Erc998Template service={ServiceType.ADMIN} /> },
          { path: "/erc998/templates/:id/:action", element: <Erc998Template service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/erc998/tokens",
        element: <Protected />,
        children: [
          { index: true, element: <Erc998Token service={ServiceType.ADMIN} /> },
          { path: "/erc998/tokens/:id/:action", element: <Erc998Token service={ServiceType.ADMIN} /> },
        ],
      },
      {
        path: "/erc998/composition",
        element: <Protected />,
        children: [
          { index: true, element: <Erc998Composition service={ServiceType.ADMIN} /> },
          { path: "/erc998/composition/:id/:action", element: <Erc998Composition service={ServiceType.ADMIN} /> },
        ],
      },
    ],
  },
];
